import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
export const getters = {
    [ReferenceValuesTypes.BRANDS]: (state) => state.referenceValues[ReferenceValuesTypes.BRANDS],
    [ReferenceValuesTypes.MARKETS]: (state) => state.referenceValues[ReferenceValuesTypes.MARKETS],
    [ReferenceValuesTypes.NAVIGATIONMENU]: (state) => state.referenceValues[ReferenceValuesTypes.NAVIGATIONMENU],
    [ReferenceValuesTypes.WEBSITE]: (state) => state.referenceValues[ReferenceValuesTypes.WEBSITE],
    [ReferenceValuesTypes.CATALOGSERVICES]: (state) => state.referenceValues[ReferenceValuesTypes.CATALOGSERVICES],
    [ReferenceValuesTypes.CATALOGCATEGORIES]: (state) => state.referenceValues[ReferenceValuesTypes.CATALOGCATEGORIES],
};
